import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { certInventoryApiRef } from './api/certInventoryApiRef';
import { CertInventoryApiClient } from './api/CertInventoryApiClient';

const certInventoryApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: certInventoryApiRef,
      deps: {
        fetchApi: fetchApiRef,
        discoveryApi: discoveryApiRef,
      },
      factory: ({ fetchApi, discoveryApi }) =>
        new CertInventoryApiClient({ fetchApi, discoveryApi }),
    }),
});

const certInventoryPage = PageBlueprint.make({
  params: {
    path: '/cert-inventory',
    loader: () =>
      import('./components/CertInventoryPage').then(m => <m.CertInventoryPage />),
  },
});

export const certInventoryPlugin = createFrontendPlugin({
  pluginId: 'cert-inventory',
  title: 'Certificate Inventory',
  icon: <VpnKeyIcon />,
  extensions: [certInventoryApi, certInventoryPage],
});
